'use client';

import { useEffect } from 'react';
import { captureException } from '@sentry/nextjs';
import { ApplicationErrorComponent } from 'components';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Next error boundaries take precedence over the SDK's global handler:
    // without this explicit capture, a CLIENT render error caught here never
    // reaches Vitals. Server-side errors are skipped — a `digest` marks an
    // error already captured server-side by onRequestError, and the copy the
    // client receives is Next's redacted placeholder (no message, no stack),
    // which would land as a second, ungroupable event.
    // console.error stays — Vercel's 1-day logs are still useful.
    if (!error.digest) {
      try {
        captureException(error);
      } catch {
        /* the reporter must never take down the recovery screen */
      }
    }
    console.error(error);
  }, [error]);

  return <ApplicationErrorComponent />;
}
